import { RemoveEventHandle } from "csi/typings";
import { without } from "lodash";

/** add a value for given key to the given object, returning a handle to remove it */
export function addToGroupedObject<T>(obj: Record<string, T[]>, key: string, value: T): RemoveEventHandle {
	let a = obj[key];
	if (!a) {
		a = obj[key] = [];
	}

	a.push(value);

	const remove = (): void => {
		obj[key] = without(obj[key], value);
	};

	return { remove };
}

/** return key for given value */
export function findKeyByValue(object: Record<string, any>, value: any): string | undefined {
	return object ? Object.keys(object)
		.find((key) => object[key] === value) : undefined;
}		

